import { GetAllObjectValue } from "#utils/objectFormatter";
import {
  FilterPillbox,
  MultiDropdownInputWithSearch,
} from "@validereinc/common-components";
import { difference, sortBy } from "es-toolkit/compat";
import React, { useEffect, useState } from "react";
import {
  clearAllInputs,
  filterInventorySourceList,
  getAllFilterInputs,
  getUniqProductTypes,
} from "../SourceTableHelper";

const DEFAULT_FILTER_DROPDOWN = {
  sites: {
    label: "site",
    inputs: [],
    options: [],
  },
  productTypes: {
    label: "product types",
    inputs: [],
    options: [],
  },
};

const useFilterInputs = (sourceList) => {
  const [filterDropdowns, setFilterDropdown] = useState({
    ...DEFAULT_FILTER_DROPDOWN,
  });

  const onDropdownSelect = (selectedValue, key) => {
    const filterDropdown = { ...filterDropdowns[key] };
    filterDropdown.inputs = selectedValue;

    setFilterDropdown({ ...filterDropdowns, [key]: filterDropdown });
  };

  const onClearFilterClick = (filterObject) => {
    if (filterObject) {
      const { filterKey, name } = filterObject;
      const updatedFilterDropdown = { ...filterDropdowns[filterKey] };

      updatedFilterDropdown.inputs = difference(updatedFilterDropdown.inputs, [
        name,
      ]);

      setFilterDropdown({
        ...filterDropdowns,
        [filterKey]: updatedFilterDropdown,
      });
    } else {
      setFilterDropdown(clearAllInputs(filterDropdowns));
    }
  };

  useEffect(() => {
    if (sourceList.length > 0) {
      const sites = { ...filterDropdowns.sites };
      // @ts-expect-error legacy opshub typing
      sites.options = sortBy(
        GetAllObjectValue(sourceList, "site_name"),
        "site_name"
      );

      const productTypes = { ...filterDropdowns.productTypes };
      // @ts-expect-error legacy opshub typing
      productTypes.options = sortBy(getUniqProductTypes(sourceList));

      setFilterDropdown({
        ...filterDropdowns,
        sites,
        productTypes,
      });
    }
  }, [sourceList]);

  const filterRow = (
    <div className="filterRow">
      {Object.keys(filterDropdowns).map((key) => {
        const { label, labelKey, options, inputs } = filterDropdowns[key];

        return (
          <MultiDropdownInputWithSearch
            key={key}
            label={label}
            labelKey={labelKey ? labelKey : null}
            dropdownKey={key}
            value={inputs}
            options={options}
            onChange={onDropdownSelect}
          />
        );
      })}
    </div>
  );

  const filterInputs = getAllFilterInputs(filterDropdowns);

  const filteredSources = filterInventorySourceList(sourceList, filterInputs);

  const filterPillbox = (
    <FilterPillbox
      filterBy={filterInputs}
      onClearFilterClick={onClearFilterClick}
    />
  );

  return [
    filterRow,
    filterPillbox,
    filteredSources,
    onDropdownSelect,
    onClearFilterClick,
  ];
};

export default useFilterInputs;
